
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.75 9.807a6 6 0 1 0-7.5 5.811v6.136a1.5 1.5 0 0 0 3 0v-6.136a6 6 0 0 0 4.5-5.811Z","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M13.563 15.75a5.972 5.972 0 0 0 2.219-.773l4.907 4.906a1.5 1.5 0 0 0 2.121-2.121l-4.91-4.906a6 6 0 0 0-8.159-8.251M5.25 9.057a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0Z","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M6.75 7.557V3a2.25 2.25 0 0 1 4.5 0v.989","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    